import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';

/** J13's gated-inline screen (CA10) — `ADMIN_ROUTE_GUARDS` only redirects silently, this route
 * needs the dedicated "Accès refusé" copy instead. */
const AccessDenied = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center gap-3 px-4 py-20 text-center">
      <Lock className="h-[44px] w-[44px] text-muted-foreground" aria-hidden="true" />
      <p className="text-[17px] font-semibold">{t('Access denied')}</p>
      <p className="max-w-[420px] text-[13.5px] text-muted-foreground">
        {t('This page is reserved for super admins and users with the “View the action journal” permission.')}
      </p>
      <button
        type="button"
        onClick={() => navigate('/admin')}
        className="mt-1 rounded-md border border-input px-3 py-1.5 text-[13px] font-medium hover:bg-accent"
      >
        {t('Back to home')}
      </button>
    </div>
  );
};

export default AccessDenied;
